var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-items-center"},[_c('button',{on:{"click":function($event){return _vm.exampleStore.increment()}}},[_vm._v("\n    Increment\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }